export const OfficeEditInstallationState = {
	url: '/installation/edit/:id',
	title: 'Office Installation Edit',
	template: '<office-installation-edit-page></office-installation-edit-page>',
	params: {id: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeInstallationEditPageMod" */
			'@Containers/office-installation-page/office-edit-installation/office-edit-installation.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
